import "./index.scss";
import React, { useState, useEffect, useRef } from "react";
import {  format, parseISO } from 'date-fns';
import formatDistanceToNow from 'date-fns/formatDistanceToNow'
import ThreeDots from "component/ThreeDots";
import api from "api";
import _ from "lodash";
import { useFormik } from 'formik';
import { popinfo } from "component/Fancybox/Fancybox";
import { AvatarHorizontal1 } from "component/Avatar";
import { QuillBuilder } from "component/RichEditor/RichEditor"

const InitiativeUpdatesForm = (props) => {
    const[BodyWYSIWYG, setBodyWYSIWYG]          = useState(false);
    const[updates]                              = useState(props.updates || false);

    const WYSIWYG = useRef();

    const settingFormValues = (formData) => {
        _.each(formData, (value, attribute) => {
            if(value === null)
            {
                value = '';
            }

            if(attribute == 'UpdatesBody')
            {
                BodyWYSIWYG.setContents(BodyWYSIWYG.clipboard.convert(value), 'silent');
            }
            
            formik.setFieldValue(attribute, value);

        });
    }

    const formik = useFormik({
        initialValues: {
            InitiativeID   : props.initiative.InitiativeID || 0
            ,UpdatesTitle  : updates ? updates.UpdatesTitle : ''
            ,UpdatesBody   : updates ? updates.UpdatesBody : ''
            ,UpdatesID     : updates ? updates.TalkID : 0
        }
        ,onSubmit: values => {
            
            let SavingLoader = popinfo('loader', 'Sending Updates',  updates ? 'Please Wait' : 'Keep your followers and co-workers happy by posting updates regularly' );

            api('/Initiative/Updates', 'post', _.assignIn({}, values, {
                UpdatesBody : BodyWYSIWYG.root.innerHTML.replaceAll("\uFEFF", '')
            }) , 'Bearer ' + props.userToken)
                .then(function(response){

                    SavingLoader.close();

                    settingFormValues(updates ? response.updates : {
                        UpdatesBody : ''
                    });

                    props.onSave.apply(null, [response.updates]);

                })
                .catch((error) => {
                    popinfo('error', 'Sending Updates', error, {}, SavingLoader);
                });
        }
    });

    useEffect(() => {

        if(BodyWYSIWYG === false)
        {
            var rte = QuillBuilder(WYSIWYG.current, props.userToken);
    
            rte.once('editor-change', () => {
                setBodyWYSIWYG(rte);
            });
    
            rte.setText('\n', 'silent');
        }

        if(updates && BodyWYSIWYG !== false)
        {
            settingFormValues(updates)
        }

    }, [BodyWYSIWYG, updates]);

    return (
        <div className="updates-form">
            <div className="wrapper">
                <div className="talk-sender">
                    <span className="image-box square circle">
                        <img src="" alt="" />
                    </span>
                </div>
                <form className="updates-form-body generic-form" onSubmit={formik.handleSubmit}>
                    <div className="form-group">
                        <input type="text" className="form-control text" 
                            onChange={formik.handleChange}
                            value={formik.values.UpdatesTitle}
                            name="UpdatesTitle"
                            placeholder="Type your updates title..."
                        />
                    </div>
                    <div id="updates-form-body-editor" ref={WYSIWYG}></div>
                    <div className="text-right mt-md">
                        {
                            (props.updates || props.onCancel) && 
                            <>
                                <a href="#" className="btn btn-orange btn-reverse" onClick={(e) => {
                                    e.preventDefault();
                                    
                                    props.onCancel.apply();

                                }}>Cancel</a> &nbsp;
                            </>
                        }
                        <input type="submit" className="btn btn-orange" value={props.updates ? "Save" : "Send"} />
                    </div>
                </form>
            </div>
        </div>
    )

}



const InitiativeUpdates = (props) => {
    const [updates, setUpdates]                         = useState(props.updates);
    const [isEditing, setIsEditing]                     = useState(false);

    /**
     * Delete current talks 
     */
    const DeleteUpdates = () => {
        let ask = window.confirm('Are You Sure ?');

        if(!ask)
        {
            return;
        }

        let DeleteLoader = popinfo('loader', 'Deleting Updates', 'Please Wait' );

        api('/Initiative/Updates', 'delete', {
            updates_id : updates.UpdatesID
        }, 'Bearer ' + props.userToken)  
            .then((response) => {
                DeleteLoader.close();

                setUpdates(response.updates)
            })
            .catch((error) => {
                popinfo('error', 'Deleting Updates', error, {}, DeleteLoader);
            })
    }

    return (
        !isEditing ?
        <div className="component-updates">
            <div className="updates-body">
                {
                    !updates.IsDelete && updates.UserID == props.user.UserID &&
                    <ThreeDots>
                        <button onClick={ (e) => {
                            e.preventDefault();
                            
                            setIsEditing(true);
                        }}>Edit</button>
                        <button onClick={ (e) => {
                            e.preventDefault();

                            DeleteUpdates();
                        }}>Delete</button>
                    </ThreeDots>
                }
                <h2 className="updates-title leading-text">{updates.UpdatesTitle}</h2>
                <AvatarHorizontal1
                    user={updates}
                    metadata={`${formatDistanceToNow(parseISO(updates.UpdatesDate), 'dd LLLL Y HH:mm:ss')} ago`}
                />
                {
                    updates.IsDelete == 0 &&
                    <div className="updates-content wp-content" dangerouslySetInnerHTML={{__html : updates.UpdatesBody}}></div>
                }
                {
                    updates.IsDelete != 0 &&
                    <span className="text-xs font-bold block italic">Updates Deleted</span>
                }
                {
                    updates.DeletingUserFirstName && 
                    <span className="mt-lg text-xs font-light block italic text-right">Deleted by {updates.DeletingUserFirstName}</span>
                }
                {
                    updates.UpdatingUserFirstName && !updates.DeletingUserFirstName && 
                    <span className="mt-lg text-xs font-light block italic text-right">Last updated by {updates.UpdatingUserFirstName} at {format(parseISO(updates.UpdatedDate), 'dd LLLL Y HH:mm:ss' )}</span>
                }
                {props.children}
            </div>
        </div> : 
        <InitiativeUpdatesForm
            initiative={props.initiative}
            userToken={props.userToken}
            user={props.user}
            updates={updates}
            onSave={(updates) => {
                setUpdates(updates);

                setIsEditing(false);
            }}
            onCancel={() => {
                setIsEditing(false);
            }}
        />
    )
};

export {InitiativeUpdates, InitiativeUpdatesForm};